import CONFIG from "../../config"
import { updateActiveAssessment } from "../../actions/assessment.action"

export const onPauseStatusesFromDevice = (assessment = {}) => {
  if (assessment.status && assessment.id) {
    CONFIG.Store.dispatch(updateActiveAssessment(assessment.id,{ status: assessment.status }))
  }
}